// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-area-multi"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M20 17.2096L7 17.2096V16.5V16L12.3257 11.1739L15.3257 14.6739L20 10L20 17.2096Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21H3V3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M20 10L20 17.2096L7 17.2096L7 16L12.3257 11.1739L15.3257 14.6739L20 10ZM20 10L19.9997 10.5M7 12.5L12.4997 7.49957L15.4997 10.9996L20 6.5V9.99957L15.3257 14.6735L12.3257 11.1735L7 15.9996L7 12.5Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-area-multi')
export default class ChartAreaMultiIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-area-multi',
    }
  }
}
